import React, { memo } from 'react';
import PropTypes from 'prop-types';
import MarketTabs from 'components/trade/MarketTabs';
import MarketMobileDropdown from 'components/trade/MarketMobileDropdown';
import MarketStats from 'components/trade/MarketStats';
import { comparePropsIgnoringFunctions } from 'helpers/memo';
import styles from './styles.module.scss';

function MarketHeader(props) {
  return (
    <div className={styles.marketHeader}>
      {!props.isMobile ? <MarketTabs {...props} /> : <MarketMobileDropdown {...props} />}
      {props.markets.loading ? <nbx-spinner /> : <MarketStats {...props} />}
    </div>
  );
}

MarketHeader.propTypes = {
  pair: PropTypes.string.isRequired,
  userId: PropTypes.string,
  tickers: PropTypes.object.isRequired,
  marketTicker: PropTypes.object.isRequired,
  trades: PropTypes.object.isRequired,
  funds: PropTypes.object.isRequired,
  markets: PropTypes.object.isRequired,
  assets: PropTypes.object.isRequired,
  preferences: PropTypes.object.isRequired,
  isMobile: PropTypes.bool
};

MarketHeader.defaultProps = {
  userId: null,
  isMobile: false
};

export default memo(MarketHeader, comparePropsIgnoringFunctions);
